/**
 * The Breadcrumbs container
 */
import PropTypes from "prop-types";
import React from "react";
import { MdHome } from "react-icons/md";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem } from "reactstrap";

/**
 * Breadcrumbs component
 *
 */

const Breadcrumbs = (props) => {
  const { breadcrumbs } = props;
  const locale = useSelector((state) => state?.i18nState?.lang);

  return (
    <>
      {breadcrumbs?.length > 0 && breadcrumbs?.map && (
        <Breadcrumb className="mb-5">
          <BreadcrumbItem>
            <Link to={`/${locale}`}>
              <MdHome />
            </Link>
          </BreadcrumbItem>
          {breadcrumbs.map((breadcrumb, index) => (
            <BreadcrumbItem key={index} active={breadcrumb.active}>
              {breadcrumb.active ? (
                <span>{breadcrumb.label}</span>
              ) : (
                <Link to={breadcrumb.target} className="text-decoration-none">
                  {breadcrumb.label}
                </Link>
              )}
            </BreadcrumbItem>
          ))}
        </Breadcrumb>
      )}
    </>
  );
};

/**  define proptype for the 'translation' function  */
Breadcrumbs.contextTypes = {
  t: PropTypes.func,
};

Breadcrumbs.propTypes = {
  breadcrumbs: PropTypes.array,
};

Breadcrumbs.defaultProps = {};

/** export the component as redux connected component */
export default Breadcrumbs;
